import React from 'react';
import { Section } from './ui/Section';
export function PainPoints() {
  const points = ['Llegas a clase sin saber qué vas a dar', 'Cobras lo mismo que hace dos años', 'Tus alumnas se van sin avisarte', 'No sabes cómo subir precios sin perder a nadie', 'Tienes talento pero te falta el sistema'];
  return <Section variant="alt" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        <h2 className="font-display md:text-4xl font-bold text-center mb-8 text-[32px] text-brand-title" data-id="element-193">
          ¿Te suena esto?
        </h2>

        <div className="bg-white border border-brand-border rounded-2xl p-8 md:p-10 mb-8 shadow-card" data-id="element-194">
          <ul className="space-y-5" data-id="element-195">
            {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-196">
                <span className="text-brand-alert text-xl mt-0.5 shrink-0" data-id="element-197">
                  😓
                </span>
                <span className="font-body text-lg text-brand-text" data-id="element-198">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-199">
          <p className="font-body text-brand-text text-lg font-medium" data-id="element-200">
            Si has marcado aunque sea uno: esto es para ti.
          </p>
        </div>
      </div>
    </Section>;
}